import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import { FlexCentered, ColumnFlex } from './common/containers'
import { getUserInfo } from '~/selectors/app'

const Row = styled(ColumnFlex)`
  padding: 12px 16px;
`

const Content = styled(ColumnFlex)`
  background-color: ${props => props.theme.backgroundViewJoinOptions};
  margin-bottom: 12px;
  border-radius: 0 0 3px 3px;

  ${Row}:first-child {
    padding-top: 16px;
  }
`

const Label = styled.span`
  margin-right: 10px;
`

const Description = styled.span`
  font-size: ${({ theme }) => theme._neo.label01.fontSize};
  color: ${props => props.theme.colorListItemIcon};
  word-break: break-word;
  margin-top: 8px;

  span {
    color: ${props => props.theme.color};
  }
`

const StyledInput = styled.div`
  padding: 1px 8px;
  box-sizing: border-box;
  color: ${props => props.theme.colorTertiary};
  background-color: ${props => props.theme.backgroundJoinOptionHint};
`

const ViewJoinOptions = ({ userInfo }) => {
  const tenant = userInfo.tenant || userInfo.pbx

  const hints = tenant
    ? [
        {
          format: translate('hint_join_simple'),
          description: translate('hint_join_with_your_company_description', {
            tenant
          })
        },
        {
          format: translate('hint_join_with_domain'),
          description: translate('hint_join_with_domain_description')
        },
        {
          format: `/${translate('hint_join_simple')}`,
          description: translate('hint_join_without_domain_description')
        }
      ]
    : [
        {
          format: translate('hint_join_simple'),
          description: translate('hint_join_without_domain_description_guest')
        },
        {
          format: translate('hint_join_with_domain'),
          description: translate('hint_join_with_domain_description_guest')
        }
      ]

  return (
    <Content>
      {hints.map(hint => (
        <Row key={hint.format}>
          <FlexCentered>
            <Label>{translate('enter')}</Label>
            <StyledInput>
              {hint.format}
            </StyledInput>
          </FlexCentered>
          <Description dangerouslySetInnerHTML={{ __html: hint.description }} />
        </Row>
      ))}
    </Content>
  )
}

const mapStateToProps = state => ({
  userInfo: getUserInfo(state)
})

export default connect(mapStateToProps)(ViewJoinOptions)
